export const invitationRoutes = {
  Invitations: '/invitations',
};

export const securityRoutes = {
  Security: '/security',
};

export const verificationRoutes = {
  PhoneVerification: '/verification/phone',
};

export const authenticatedRoutes = {
  root: '/',
  Profile: '/profile',

  ...securityRoutes,
  ...invitationRoutes,
  ...verificationRoutes,
};

export const unauthenticatedRoutes = {
  SignIn: '/signin',
  ResetPassword: '/resetpassword',
  AcceptInvitation: '/invitations/accept',
  MultiFactorAuth: '/auth/two-factor',
};

export const AppRoutes = {
  ...authenticatedRoutes,
  ...unauthenticatedRoutes,
};
